<script setup lang="ts">
import { Button } from '@laam/ui/base';
import { PhWhatsappLogo } from '@phosphor-icons/vue';
import { useGlobalStore } from '~/stores/global';
const { store } = useGlobalStore();
</script>
<template>
	<div class="py-md gap-3xl flex flex-col">
		<div class="gap-md flex flex-col">
			<p class="text-lg font-semibold text-gray-900">Need help?</p>
			<div class="text-sm text-gray-600">
				Email
				<a
					class="hover:cursor-pointer text-blue-600"
					:href="`mailto:${store.meta_data?.email}`"
				>
					{{ store.meta_data?.email }}
				</a>

				or Whatsapp us on
				<a
					:href="`${store.meta_data?.whatsapp}`"
					target="_blank"
					style="color: #868686"
				>
					<span class="font-medium">{{ store.meta_data?.phone }} </span>
				</a>
			</div>
			<p class="text-sm font-semibold text-gray-600">
				Monday to Saturday 10am - 6pm PST
			</p>
		</div>
		<NuxtLink :to="`${store.meta_data?.whatsapp}`" target="_blank">
			<Button variant="secondary" size="lg" class="w-fit">
				<template #leftIcon>
					<PhWhatsappLogo size="24" />
					Chat with an expert
				</template>
			</Button>
		</NuxtLink>
	</div>
</template>
